// import API from "../../../app/api";

// export const addToCart = async (payload) => {
//   try {
//     const response = await API.post("/cart", payload);
//     return response.data;
//   } catch (error) {
//     console.error("Cart API Error:", error.response?.data || error);
//     throw error;
//   }
// };

// import API from "../../../app/api";

// export const addToCart = async (payload) => {
//   try {
//     const response = await API.post("/cart", payload);

//     return response.data;
//   } catch (error) {
//     console.log("API Error:", error.response?.data);
//     throw error;
//   }
// };

// import API from "../../../app/api";

// export const addToCart = async (payload) => {
//   try {
//     const response = await API.post("/cart", payload);

//     // 🔥 normalize response (VERY IMPORTANT)
//     return response?.data;
//   } catch (error) {
//     console.log("API Error:", error.response?.data || error.message);
//     throw error;
//   }
// };


import API from "../../../app/api";

export const addToCart = async (payload) => {
  try {
    const response = await API.post(
      `/cart/add-to-cart`,
      payload
    );

    return response?.data;
  } catch (error) {
    console.log("AddToCart API Error:", error?.response?.data || error.message);
    throw error;
  }
};